<template>
  <div>关注</div>
</template>

<script>
export default {
  name: "follow"
}
</script>

<style scoped>

</style>
